import React from "react";

import Slider from "rc-slider";

function CustomSlider({
  value,
  onChange = () => {},
  max = 45,
  min = 18,
  stepDifference = 10,
  isDisabled = false,
}) {
  // Validate inputs
  if (max === undefined || isNaN(max)) return null;

  const safeMin = min ?? 0;
  const safeMax = max;

  // Calculate number of steps based on stepDifference
  const calculateSteps = (min, max, diff) => Math.ceil((max - min) / diff);
  const steps = calculateSteps((safeMin / safeMax) * 100, 100, stepDifference);

  // Calculate step size
  const stepSize = (safeMax - safeMin) / steps;

  // Generate options with precise calculation
  const options = Array.from(
    { length: steps + 1 },
    (_, i) => ((safeMin + i * stepSize) / safeMax) * 100
  );
  const stepGap =
    ((safeMin + 1 * stepSize) / safeMax) * 100 - (safeMin / safeMax) * 100;

  return (
    <div className="range-area">
      <p className="p-0 m-0">
        Logo Width <span>(Select Logo Size)</span>
      </p>

      <div className="d-flex align-items-center">
        <div className="left-side d-flex flex-column">
          <div className="scale-container">
            <div className="scale-markers">
              {options.map((num, i) => {
                const classConfig =
                  i === Math.floor(options.length / 2) ||
                  i === 0 ||
                  i === options.length - 1
                    ? "first-and-last"
                    : "";
                return (
                  <div key={i}>
                    <div className={`marker ${classConfig}`}></div>
                    <div className="marker-label">
                      {num.toFixed(0) === "71"
                        ? 70
                        : num.toFixed(0) === "81"
                        ? 80
                        : num.toFixed(0)}
                      %
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <Slider
            disabled={isDisabled}
            max={options?.[options?.length - 1]}
            min={options?.[0]}
            step={stepGap}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
      <label className="slider-label text-muted m-0">
        All measurements are in millimetres. (Slider calculation based on the
        image width.)
      </label>
    </div>
  );
}

export default CustomSlider;
